/**
 * 登录设备页 / 两步验证页懒加载壳（14.34b-3；MyAccountsLazy 同构）：
 * 低频管理页不进首屏 bundle，各自独立 chunk（uqr 由 2FA 页内再按需 import）。
 */
import { useLazyModule } from './useLazyModule';
import { useEffect, useState } from 'preact/hooks';
import type * as TwoFaModule from './TwoFaPage';

export function LoginDevicesLazy() {
  const { mod } = useLazyModule(() => import('./LoginDevicesPage'));
  if (mod === null) return <div data-testid="devices-loading-shell">加载中…</div>;
  return <mod.LoginDevicesPage />;
}

export function TwoFaLazy() {
  const [mod, setMod] = useState<typeof TwoFaModule | null>(null);
  useEffect(() => {
    let cancelled = false;
    void import('./TwoFaPage').then((m) => {
      if (!cancelled) setMod(m);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  if (mod === null) return <div data-testid="twofa-loading-shell">加载中…</div>;
  return <mod.TwoFaPage />;
}
